/**
 * App base path. Set when the app is mounted under a sub-path so internal
 * routes can be prefixed at navigation/href time. Kept in its own module so
 * UI code can read it without pulling in the axios client and its
 * interceptors.
 */
export const BASE_PATH = process.env.BASE_PATH || ''
